// Fichier de données statiques pour tests d'affichage et d'actions sur les lignes MEJ
// Placer ce fichier dans src/app/common/const/omni-ligne-mej-data.ts

export const OMNI_LIGNE_MEJ_DATA = [
  {
    id: 1,
    numeroLigne: '001',
    identifiantCredit: 'CRD-1001',
    produitLibelle: 'Produit A',
    sousProduitLibelle: 'Sous-produit A1',
    institutionLibelle: 'Institution X',
    montantReclame: 10000,
    dateReception: '2025-08-01T10:00:00',
    analysteLibelle: 'Analyste 1',
    statut: 'Accepté',
    dateEcheance: '2025-09-01T00:00:00',
    montantCRD: 5000,
    motifDemandeMEJ: 'Motif test 1',
    datePremierImpaye: '2025-07-15T00:00:00',
    modifierLe: '2025-08-10T09:00:00',
    modifierPar: 'Utilisateur 1',
  },
  {
    id: 2,
    numeroLigne: '002',
    identifiantCredit: 'CRD-1002',
    produitLibelle: 'Produit B',
    sousProduitLibelle: 'Sous-produit B1',
    institutionLibelle: 'Institution Y',
    montantReclame: 20000,
    dateReception: '2025-08-02T11:00:00',
    analysteLibelle: 'Analyste 2',
    statut: 'Rejeté',
    dateEcheance: '2025-09-02T00:00:00',
    montantCRD: 8000,
    motifDemandeMEJ: 'Motif test 2',
    datePremierImpaye: '2025-07-16T00:00:00',
    modifierLe: '2025-08-11T10:00:00',
    modifierPar: 'Utilisateur 2',
  },
  {
    id: 3,
    numeroLigne: '003',
    identifiantCredit: 'CRD-1003',
    produitLibelle: 'Produit C',
    sousProduitLibelle: 'Sous-produit C1',
    institutionLibelle: 'Institution Z',
    montantReclame: 15000,
    dateReception: '2025-08-03T12:00:00',
    analysteLibelle: 'Analyste 3',
    statut: 'Accepté',
    dateEcheance: '2025-09-03T00:00:00',
    montantCRD: 12000,
    motifDemandeMEJ: 'Motif test 3',
    datePremierImpaye: '2025-07-17T00:00:00',
    modifierLe: '2025-08-12T11:00:00',
    modifierPar: 'Utilisateur 3',
  },
  {
    id: 4,
    numeroLigne: '004',
    identifiantCredit: 'CRD-1004',
    produitLibelle: 'Produit D',
    sousProduitLibelle: 'Sous-produit D1',
    institutionLibelle: 'Institution X',
    montantReclame: 5000,
    dateReception: '2025-08-04T13:00:00',
    analysteLibelle: 'Analyste 4',
    statut: 'Rejeté',
    dateEcheance: '2025-09-04T00:00:00',
    montantCRD: 3000,
    motifDemandeMEJ: 'Motif test 4',
    datePremierImpaye: '2025-07-18T00:00:00',
    modifierLe: '2025-08-13T12:00:00',
    modifierPar: 'Utilisateur 4',
  },
];
